import { render, staticRenderFns } from "./ValidationList.vue?vue&type=template&id=6a989c17&"
import script from "./ValidationList.vue?vue&type=script&lang=js&"
export * from "./ValidationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports